import React from 'react';
import { Github, Mail, MessageCircle, ArrowUp } from 'lucide-react';
import { personalInfo } from '../data/personal';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-ink-900 border-t border-slate-700/60">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <div className="text-xl font-bold bg-gradient-to-r from-emerald-400 to-gold-400 bg-clip-text text-transparent">
              {personalInfo.name}
            </div>
            <p className="text-slate-400 text-sm mt-1">
              {personalInfo.title} · {personalInfo.location}
            </p>
          </div>

          <div className="flex items-center gap-3">
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-slate-300 hover:text-white hover:border-emerald-400/40 hover:bg-white/10 transition-all duration-300"
            >
              <Github className="w-5 h-5" />
            </a>
            <a
              href={`mailto:${personalInfo.email}`}
              aria-label="Email"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-slate-300 hover:text-white hover:border-emerald-400/40 hover:bg-white/10 transition-all duration-300"
            >
              <Mail className="w-5 h-5" />
            </a>
            <a
              href="https://wa.me/+963996697253"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white/5 border border-white/10 text-slate-300 hover:text-white hover:border-green-400/40 hover:bg-white/10 transition-all duration-300"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
            <button
              onClick={scrollToTop}
              aria-label="Back to top"
              className="btn-primary w-10 h-10 flex items-center justify-center rounded-full hover:-translate-y-0.5"
            >
              <ArrowUp className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-2 text-center">
          <p className="text-slate-500 text-sm">
            © {year} {personalInfo.name}. Crafted with passion and precision.
          </p>
          <p className="text-slate-600 text-xs">
            Built with React &amp; Tailwind CSS
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
